// The quiet manager's check-in (scenario J3,
// PLAN-2026-11-01-the-quiet-manager-check-in): whether the site is asking me
// if I'm still in, and my answer. A real league's alone: the practice league
// asks nobody.

import { CheckInView, type Snapshot } from '@fsp/domain';
import { messageOf, send } from './api';
import { useRead } from './read';

export function useCheckIn(leagueId: string | null, refresh = 0): Snapshot<CheckInView | null> {
  return useRead(leagueId === null ? null : `/leagues/${leagueId}/check-in`, CheckInView, {
    refresh,
  }).snapshot;
}

/** My answer: `in`, or `leave` to step back (a bot plays my team, or its co-manager runs it). */
export async function answerCheckIn(
  leagueId: string,
  answer: 'in' | 'leave',
): Promise<{ ok: true; view: CheckInView } | { ok: false; message: string }> {
  const reply = await send('POST', `/leagues/${leagueId}/check-in`, { answer }, CheckInView);
  if (reply.status === 'ok') return { ok: true, view: reply.data };
  return {
    ok: false,
    message: messageOf(
      reply,
      'That did not go through. Try again.',
      'Could not reach the site. Nothing changed.',
    ),
  };
}
